import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { List } from './List';
import { AddEditCase } from './AddEditCase';
import { ViewCase } from './ViewCase';
import ProtectedRoute from '../PrivateRoute';

function Cases({ match }) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={List} />
            <Route path={`${path}/add`} component={AddEditCase} />
            <Route path={`${path}/edit/:id`} component={AddEditCase} />
            <Route path={`${path}/view/:id`} component={ViewCase} />
        </Switch>
    );
}

export { Cases };